import Constant from '@/common/constant/Constant';
import { useState, useEffect } from 'react';
import RichTextEditor from '@/component/formManagement/fieldUI/RichTextEditor';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ReplyCheckboxDeliver({
    originTicket,
    replyToEmailTicket,
    replyDeliverStatus,
    setReplyDeliverStatus,
    currentEmailTicket,
    currentTicketDeliverStatus,
    setCurrentTicketDeliverStatus,
    setIsEdited                    
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    return (
        <div className='form-addTicket'>
            <FormControlLabel
                control={
                        <Checkbox 
                        checked={replyDeliverStatus} 
                        onChange={e => setReplyDeliverStatus(!replyDeliverStatus)}
                    />
                }
                label={tr('メール配信')} 
                className={`checkbox-item-of-tag-field`}
            />
        </div>
    );

}
